import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { seoGuard } from './seoGuard'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/buy-properties',
    name: 'BuyProperty',
    component: () => import('../views/PropertiesView.vue')
  },
  {
    path: '/rent-properties',
    name: 'RentProperty',
    component: () => import('../views/PropertiesView.vue')
  },
  {
    path: '/property-list',
    name: 'PropertyList',
    component: () => import('../views/PropertiesView.vue')
  },
  {
    path: '/properties',
    name: 'Properties',
    component: () => import('../views/PropertiesView.vue')
  },
  {
    path: '/property-details',
    name: 'PropertyDetails',
    component: () => import('../views/PropertyDetails.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Add SEO guard to all routes
router.beforeEach(seoGuard)

export default router
